import React from 'react';

const ListCard = ({ title, children }) => (
  <div className="bg-white rounded-xl border border-stone-200 overflow-hidden">
    <div className="px-6 py-4 border-b border-stone-200 bg-stone-50">
      <h3 className="font-medium text-stone-900">{title}</h3>
    </div>
    <div className="divide-y divide-stone-100 max-h-96 overflow-y-auto">{children}</div>
  </div>
);

export const UsersPanel = ({ dashboardData }) => (
  <ListCard title="Registered Users">
    {dashboardData.recent_users.length === 0 ? (
      <p className="px-6 py-8 text-center text-stone-500">No users yet</p>
    ) : (
      dashboardData.recent_users.map((user, idx) => (
        <div key={idx} className="px-6 py-4 flex justify-between items-center">
          <div>
            <p className="font-medium text-stone-900">{user.name || 'Anonymous'}</p>
            <p className="text-sm text-stone-500">{user.email}</p>
          </div>
          <div className="text-right">
            <span className="text-xs bg-stone-100 px-2 py-1 rounded-full">{user.auth_provider || 'email'}</span>
            <p className="text-xs text-stone-400 mt-1">{new Date(user.created_at).toLocaleDateString()}</p>
          </div>
        </div>
      ))
    )}
  </ListCard>
);

export const VisitReportsPanel = ({ dashboardData }) => (
  <ListCard title="Venue Visit Reports">
    {dashboardData.recent_experiences.length === 0 ? (
      <p className="px-6 py-8 text-center text-stone-500">No visit reports yet</p>
    ) : (
      dashboardData.recent_experiences.map((exp, idx) => (
        <div key={idx} className="px-6 py-4">
          <div className="flex justify-between items-start">
            <div>
              <p className="font-medium text-stone-900">{exp.venue_name}</p>
              <p className="text-sm text-stone-500">by {exp.user_name || 'Anonymous'}</p>
            </div>
            <div className="text-right">
              <span className={`text-xs px-2 py-1 rounded-full ${exp.is_verified_venue ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-700'}`}>
                {exp.is_verified_venue ? 'Verified' : 'Unverified'}
              </span>
              <p className="text-xs text-stone-400 mt-1">{new Date(exp.created_at).toLocaleDateString()}</p>
            </div>
          </div>
        </div>
      ))
    )}
  </ListCard>
);

export const VerificationPanel = ({ dashboardData }) => (
  <ListCard title="Venue Verification Requests">
    {dashboardData.recent_verification_requests.length === 0 ? (
      <p className="px-6 py-8 text-center text-stone-500">No verification requests yet</p>
    ) : (
      dashboardData.recent_verification_requests.map((req, idx) => (
        <div key={idx} className="px-6 py-4">
          <div className="flex justify-between items-start">
            <div>
              <p className="font-medium text-stone-900">{req.venue_name}</p>
              <p className="text-sm text-stone-500">
                Requested by {req.user_name || 'Anonymous'} • {req.user_email}
              </p>
              {req.notes && <p className="text-sm text-stone-400 mt-1">{req.notes}</p>}
            </div>
            <div className="text-right">
              <span className={`text-xs px-2 py-1 rounded-full ${req.status === 'pending' ? 'bg-amber-100 text-amber-700' : 'bg-green-100 text-green-700'}`}>
                {req.status}
              </span>
              <p className="text-xs text-stone-400 mt-1">{new Date(req.created_at).toLocaleDateString()}</p>
            </div>
          </div>
        </div>
      ))
    )}
  </ListCard>
);

export const TopVenuesPanel = ({ dashboardData }) => (
  <ListCard title="Most Searched Venues">
    {dashboardData.top_searched_venues.map((venue, idx) => (
      <div key={idx} className="px-6 py-4 flex justify-between items-center">
        <div className="flex items-center gap-3">
          <span className="w-8 h-8 bg-stone-100 rounded-full flex items-center justify-center text-sm font-medium">
            {idx + 1}
          </span>
          <div>
            <p className="font-medium text-stone-900">{venue.name}</p>
            {venue.location && <p className="text-sm text-stone-500">{venue.location}</p>}
          </div>
        </div>
        <span className="text-lg font-bold text-amber-600">{venue.search_count}</span>
      </div>
    ))}
  </ListCard>
);
